import { useTranslation } from 'react-i18next';
import styles from './PromoModal.module.scss';
import { Button } from 'antd';

const ResendOTPPromo = ({ options, onSelect, setIsResend }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className={styles.servicesContainer}>
        {options?.map((service) => (
          <button
            data-testId={service.value}
            key={service.value}
            type="button"
            className={styles.serviceButton}
            onClick={() => {
              onSelect(service);
            }}>
            <img width={24} height={24} src={service.icon} alt={service.label} />
            <div>{t('sendOtp.receive_code', { service: service.label })}</div>
          </button>
        ))}
      </div>
      <Button
        color="default"
        variant="filled"
        size="large"
        style={{
          width: '100%',
          height: 30,
          marginTop: 8
        }}
        onClick={() => setIsResend(false)}>
        {t('common.cancel')}
      </Button>
    </div>
  );
};

export default ResendOTPPromo;
